import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-702f6ed2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid justify-items-center text-center" }
const _hoisted_2 = { class: "text-white text-2xl font-bold font-sans mt-5 mb-5" }
const _hoisted_3 = { class: "text-white font-sans mb-5 text-sm" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white font-sans" }, " Check your wallet to view your new NFT! ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.n.metadataExternal.name), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        class: "underline",
        href: 'https://explorer.solana.com/address/' + _ctx.n.mint,
        target: "new"
      }, _toDisplayString(_ctx.n.mint), 9, _hoisted_4)
    ]),
    _hoisted_5
  ]))
}